import React from 'react';
import Layout from '../layouts/six';
import Title from '../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

// August 7th: refactored for responsiveness
class WeatherPolicy extends React.Component {

    render() {
        return <Layout nbs="information" title="WEATHER POLICY" bi="/images/backgrounds/mud2.jpg">
            <section>
                <div className="w3-white">
                    <div className="w3-container w3-content">
                        <div style={{ height: 50 }} />
                        <Title text="WEATHER POLICY / PROCEDURES" className="black" />
                        <figure className="w3-card bg-red white margin-top p-4">
                            <div><strong>Challenge Sports procedures in case of inclement weather</strong></div>
                            <span>(These apply to events run by Challenge Sports only. Independent affiliate events set their own policies)</span>
                        </figure>
                    </div>
                </div>
                <div className="w3-white">
                    <div className="d-flex flex-row w3-container w3-content pb-8 pt-4" >
                        <div className="w-100 d-flex flex-column justify-content-center">
                            <Title text="PRIOR TO THE DAY OF THE EVENT" />
                            <p className="gray hind margin-top">The Tournament Director will make the decision regarding schedule changes, delays or postponement due to the forecasted weather or field conditions.</p>
                            <p className="gray hind">Teams are responsible for checking www.challengesports.com for information regarding the impact of weather on the event. If a tournament is postponed before the start, teams will have the option to transfer their entry to a future Challenge 3v3 Tournament.</p>
                        </div>
                        <div style={{ width: 40 }} />
                        <ScrollAnimation animateIn="fadeInUp" animateOnce={true} className="w-100">
                            <img alt="" className="w-100" src="/images/others/rainbow.jpg" />
                        </ScrollAnimation>
                    </div>
                </div>
                <div className="w3-container d-flex flex-column justify-content-center pt-8 pb-4" style={{
                    background: 'url("/images/backgrounds/net.jpg") no-repeat center top', backgroundSize: 'cover', position: 'relative'
                }}>
                    <div className="w3-content">
                        <Title text="DURING THE EVENT" className="white" />
                        <p className="white margin-top">We will play in the rain.... if weather becomes severe, particularly in the case of Storms with Lightning, play will be suspended until conditions improve and it is safe to resume play. Conditions will be checked every 30 minutes and the decision to resume play will be considered every 30 minutes until play can be resumed. If this happens we want the participants to be safe and ask that they return to and remain in their vehicles and stay off of the fields until the all clear is given. Please DO NOT LEAVE THE FACILITY. As soon as it is determined it is safe to resume play we will. Also please understand that even though there might be a pause in playing, games can get back on their regular schedules rather quickly.</p>
                    </div>
                </div>
                <div className="bg-red">
                    <div className="w3-container w3-content pt-4 pb-2">
                        <p className="white">If an event is terminated because of weather while in progress, the Tournament Committee will make a
determination about results of games in progress, Division standings and qualifying for Nationals.</p>
                    </div>
                </div>
            </section>
        </Layout>
    }
}

export default WeatherPolicy;



// WEBPACK FOOTER //
// ./src/components/information/weather.js